<script lang="ts" setup>
import CatalogProductCard from "~/entities/catalog/products/content/CatalogProductCard.vue"
import Slider from "~/components/ui/slider/Slider.vue"
import type { ICatalogProduct } from "~/shared/interfaces/catalog"
import type { SwiperOptions } from "swiper/types"

const props = withDefaults(
  defineProps<{
    products: ICatalogProduct[];
    sectionTitle: string;
    isCardWithoutButton?: boolean;
    quantityForSlider?: number;
  }>(),
  {
    isCardWithoutButton: true,
    quantityForSlider: 6,
  }
);

const SliderBreakPoints: SwiperOptions["breakpoints"] = {
  320: {
    slidesPerView: "auto",
    spaceBetween: 16,
  },
  1200: {
    slidesPerView: props.quantityForSlider,
    spaceBetween: 24,
  },
};
</script>

<template>
  <section class="products">
    <div class="container">
      <h2>{{ sectionTitle }}</h2>
      <Slider
        :content="products"
        class="products__slider"
        :hasControls="true"
        slider-name="productsSlider"
        :sliderBreakpoints="SliderBreakPoints"
      >
        <template v-slot:contentItem="product">
          <CatalogProductCard
            :without-button="isCardWithoutButton"
            size="sm"
            :product="product.contentItem"
          />
        </template>
      </Slider>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.container {
  @include md-breakpoint {
    padding: 0;
  }
}

:deep(.swiper) {
  @include md-breakpoint {
    padding: 0 28px !important;
  }
  @include sm-breakpoint {
    padding: 0 20px !important;
  }
}

:deep(.swiper-wrapper) {
  align-items: stretch;
}

:deep(.swiper-slide) {
  height: auto;
  @include md-breakpoint {
    width: 152px;
  }
}
</style>
